module.exports = __webpack_public_path__ + "static/gallery-img-6-48da9040bc49163460a21c2fc44d3863.jpg";